import type { StateCreator } from 'zustand';

import type { DownloadItem } from '@/models/download';
import type { StoreType } from '.';

export type DownloadSlice = {
   downloads: DownloadItem[];
   addDownload: (download: DownloadItem) => void;
   updateDownload: (
      downloadId: string,
      changes: Partial<Omit<DownloadItem, 'id'>>,
   ) => void;
   removeDownload: (downloadId: string) => void;
   clearDownloads: () => void;
};

export const downloadSlice: StateCreator<StoreType, [], [], DownloadSlice> = (
   set,
) => ({
   downloads: [],
   addDownload: (download: DownloadItem) =>
      set((state) => ({ downloads: [download, ...state.downloads] })),
   updateDownload: (
      downloadId: string,
      changes: Partial<Omit<DownloadItem, 'id'>>,
   ) =>
      set((state) => ({
         downloads: state.downloads.map((download) =>
            download.id === downloadId ? { ...download, ...changes } : download,
         ),
      })),
   removeDownload: (downloadId: string) =>
      set((state) => ({
         downloads: state.downloads.filter(
            (download) => download.id !== downloadId,
         ),
      })),
   clearDownloads: () => set({ downloads: [] }),
});
